import {Application, ApplicationName, formatApplication} from "../administration/applications/Application";
import {formatRole, RoleName} from "../administration/users/Role";
import {useAxios} from "../shared/technical/rest/AxiosProvider";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {getApplication} from "../administration/applications/ApplicationsApi";
import {Card, CardActionArea, CardContent, CardHeader} from "@mui/material";
import Typography from "@mui/material/Typography";

export function ApplicationCard(props: {
  applicationName: ApplicationName,
  role?: RoleName
}) {
  const axios = useAxios();
  const {t} = useTranslation();
  const [application, setApplication] = useState<Application>()

  useEffect(() => {
    getApplication(axios, props.applicationName).then(setApplication);
  }, [axios, props.applicationName])

  if (!application) {
    return <></>
  }

  return (
    <Card variant={"outlined"}>
      <CardActionArea href={application?.url!!} target={'_blank'}>
        <CardHeader title={formatApplication(application)}/>
        <CardContent>
          <Typography variant="body2" color="textPrimary" component="p" style={{opacity: 0.5}}>
            {props.role && (t('User.role') + ': ' + formatRole(application, props.role))}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
